<template>

  <div id="courseDetail"  class="well" style="padding: 0 1em;">

			<table style="text-align:left" class="table" v-if="null != inputData">
				<thead>
					<tr><th><h3>{{inputData[0].courseName}}</h3></th><th></th></tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<div><span>屬性類別：</span><span>{{inputData[0].courseClass}}</span></div>
						</td>
					</tr>
					<tr class="table-success">

						<td>
						<div><span>開課日期：：</span><span>{{inputData[0].sdate}}</span></div>
						</td>
					</tr>
          			<tr>
						<td>
							<div><span>課程名稱：</span><span>{{inputData[0].courseName}}</span></div>
						</td>
					</tr>
					<tr class="table-success">

						<td>
						<div><span>起訖日期：</span><span>{{inputData[0].sdate}}&nbsp;~&nbsp;{{inputData[0].edate}}</span></div>
						</td>
					</tr>
          			<tr>
						<td>
							<div><span>上課時間：</span><span>星期{{inputData[0].week}}&nbsp;{{inputData[0].stime}}&nbsp;~&nbsp;{{inputData[0].etime}}</span></div>
						</td>
					</tr>
					<tr class="table-success">

						<td>
						<div><span>課程簡介：</span><span v-html="inputData[0].courseIntroduce"></span></div>
						</td>
					</tr>
          			<tr>
						<td>
							<div><span>課程費用：</span><span>{{inputData[0].courseCost}}</span></div>
						</td>
					</tr>
					<tr class="table-success">

						<td>
						<div><span>地點：</span><span>{{inputData[0].courseAddr}}</span></div>
						</td>
					</tr>
          	<tr>
						<td>
							<div><span>聯絡專線：</span><span>{{inputData[0].courseTel}}</span></div>
						</td>
					</tr>
					<tr class="table-success">

						<td>
						<div><span>Email：</span><span>{{inputData[0].email}}</span></div>
						</td>
					</tr>
          	<tr>
						<td>
							<div><span>上課老師：</span><span>{{inputData[0].teacherName}}教授</span></div>
						</td>
					</tr>
					<tr class="table-success">
						<td>
              <div><span>詳細網址：</span><span><a :href="inputData[0].link" target="_blank">{{inputData[0].link}}</a></span></div>

						</td>
					</tr>
	        <tr>
						<td style="text-align:center">
							<div><span><a href="#" @click.prevent="back" >回上一頁</a></span><span></span></div>
						</td>
					</tr>
				</tbody>
			</table>

  </div>
</template>

<script>
import * as tools from '../tool'
export default {
  name: 'courseDetail',
  props: [
    'id'
  ],
  data () {
    return {
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      cid: '',
      pageSize: 10,
      queryInfo: {
        sysId: 0

      }

    }
  },
  computed: {

    	filteredDocs: function () {
      let data = []

      if (this.inputData != null) {
        data = this.inputData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return data
    }
  },
  methods: {
    back () {
      this.$router.back()
    }

  },
  created () {
    console.log('======created searchView =====')
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1

    const vm = this
    if (this.$props.id != undefined) { vm.cid = this.$props.id } else { vm.cid = this.$route.query.cid }
    console.log(this.$attrs.id)
    this.$http.get('../WebApi/ociaRep/GetociaCourseDetail/'.concat(vm.cid))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data
          console.log(vm.inputData)
        }
      })
      .catch(function (error) {
        tools.showAlert(vm.inputData, 'danger', '網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
